module.exports = __webpack_public_path__ + "fonts/Inter-Bold.c3c9f10.woff2";